import {
    types
} from "../types/types";

export const authReducer = (state = null, action) => {
    switch (action.type) {
        case types.login:

            return {
                uid: action.payload.uid,
                name: action.payload.displayName,
                email: action.payload.email,
                photoURL: action.payload.photoURL,
                accessToken: action.payload.accessToken
            }

        case types.logout:
            return null;

        default:
            return state;
    }
}